var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sfcNodeContainer",
      on: {
        mouseenter: function ($event) {
          $event.stopPropagation()
          return _vm.onMouseenter($event)
        },
        mouseleave: function ($event) {
          $event.stopPropagation()
          return _vm.onMouseleave($event)
        },
      },
    },
    [
      _vm.data.type === "start"
        ? _c("SFCStartNode", {
            attrs: {
              nodeList: _vm.nodeList,
              data: _vm.data,
              isMouseEnter: _vm.isMouseEnter || _vm.isCurrentMouseEnter,
            },
          })
        : _vm.data.type === "end"
        ? _c("SFCEndNode", { attrs: { data: _vm.data } })
        : _vm.data.type === "condition"
        ? _c("SFCConditionNode", {
            attrs: {
              nodeList: _vm.nodeList,
              data: _vm.data,
              isMouseEnter: _vm.isMouseEnter || _vm.isCurrentMouseEnter,
            },
          })
        : _c("SFCNormalNode", {
            attrs: {
              nodeList: _vm.nodeList,
              childrenList: _vm.childrenList,
              data: _vm.data,
              belongConditionNodeData: _vm.belongConditionNodeData,
              isMouseEnter: _vm.isMouseEnter || _vm.isCurrentMouseEnter,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }